//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BaseUiAccordionFaq',

  props: {
    items: {
      type: Array,
      default: () => []
    },

    allowMultiple: {
      type: Boolean,
      default: false
    },

    initialOpenIndex: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {
      activeIndexes: this.initialOpenIndex >= 0 ? [this.initialOpenIndex] : []
    }
  },

  methods: {
    isOpen(index) {
      return this.activeIndexes.includes(index)
    },

    toggle(index) {
      if (this.allowMultiple) {
        const found = this.activeIndexes.indexOf(index)
        if (found > -1) {
          this.activeIndexes.splice(found, 1)
        } else {
          this.activeIndexes.push(index)
        }
      } else if (this.isOpen(index)) {
        this.activeIndexes = []
      } else {
        this.activeIndexes = [index]
      }

      this.$emit('toggle', { index, isOpen: this.isOpen(index) })
    },

    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },

    enter(el) {
      el.style.transition =
        'height 350ms cubic-bezier(0.4, 0, 0.2, 1), opacity 250ms ease'
      /* eslint-disable-next-line no-unused-expressions */
      el.offsetHeight
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = '1'
    },

    afterEnter(el) {
      el.style.height = 'auto'
    },

    beforeLeave(el) {
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = '1'
      /* eslint-disable-next-line no-unused-expressions */
      el.offsetHeight
    },

    leave(el) {
      el.style.transition =
        'height 350ms cubic-bezier(0.4, 0, 0.2, 1), opacity 250ms ease'
      el.style.height = '0'
      el.style.opacity = '0'
    },

    afterLeave(el) {
      el.style.height = '0'
    }
  }
}
